import { withUrl, get, ItemRequest } from '@factorin/rest';


export enum MonitorCardsCodes {
    K1 = 'K1',
    K2 = 'K2',
    K3 = 'K3',
    K4 = 'K4',
    K5 = 'K5',
    K6 = 'K6',
    K7 = 'K7',
    K8 = 'K8',
}

export interface MonitoringElement {
    id: string;
    code: MonitorCardsCodes;
    title: string;
    text: string;
    link: string;
    order: number;
}


const monitoringPart = withUrl('MarketsMonitor');

export const monitoring = {
    itemList: get<void, string[]>(() => monitoringPart()),
    item: get<ItemRequest, MonitoringElement>(({ id }) => monitoringPart({ path: `${id}` })),
    list: get<void, MonitoringElement>(
        () => monitoringPart({
            path: 'list',
        }),
    ),
};
